import { text } from '@clack/prompts'
import as from 'ansis'
import { Command } from 'commander'

import { generateDocumentationFile } from '@/helpers/documentation'
import { output } from '@/helpers/std-out'
import { measureTime } from '@/helpers/time'

export function GenerateReadmeCommand() {
  const cmd = new Command('generate')

  cmd.description('Self generate documentation for the cli')
  cmd.option(
    '-o, --output [file]',
    'Path where the documentation file will be written',
  )
  cmd.action(async ({ output: __outputPath }) => {
    const getOutputPath = async () => {
      if (__outputPath !== undefined && typeof __outputPath === 'string') {
        return __outputPath
      }

      const outputPath = await text({
        message: 'Where should the documentation file be written?',
        defaultValue: './README.md',
        placeholder: './README.md',
      })

      if (typeof outputPath !== 'string') {
        return output
          .error()
          .message('Operation cancelled by user')
          .exit('error')
      }

      return outputPath
    }

    const outputPath = await getOutputPath()

    const { executionTimeMs } = await measureTime(() =>
      generateDocumentationFile(outputPath),
    )

    output
      .info()
      .line()
      .title(as.green('Documentation Generated Successfully! 🎉'))
      .line()
      .message(`✨ Documentation has been generated at: ${as.blue(outputPath)}`)
      .line(
        `⏱️ Generation completed in ${as.yellow(executionTimeMs.toFixed(2))}ms`,
      )
      .line('')
      .exit('success')
  })

  return cmd
}
